import { render, staticRenderFns } from "./MenuReutilizable.vue?vue&type=template&id=227a2a9c&scoped=true"
import script from "./MenuReutilizable.vue?vue&type=script&lang=js"
export * from "./MenuReutilizable.vue?vue&type=script&lang=js"
import style0 from "./MenuReutilizable.vue?vue&type=style&index=0&id=227a2a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227a2a9c",
  null
  
)

export default component.exports